import { types } from '@actions/authentication';
import { getUserId, getToken } from '@services/authenticationResource';
import { types as conferenceTypes } from '@actions/conference';

const forgotPasswordFormInitialState = {
  forgotPasswordLoading: false,
  forgotPasswordFormRequestSuccess: false,
  forgotPasswordFormRequestFail: false,
  forgotPasswordFormChangeSuccess: false,
  forgotPasswordFormChangeFail: false,
};

const initialState = {
  loginLoading: false,
  rolesLoading: true,
  successfulLogin: undefined,
  userId: getUserId(),
  token: getToken(),
  permission: null,
  email: undefined,
  username: undefined,
  isResetingPassword: false,
  ...forgotPasswordFormInitialState,
  otp: null,
  twoFactorAuthBlocked: true,
  attemptsCountExhausted: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOGIN.STARTED:
      return {
        ...state,
        loginLoading: true,
        rolesLoading: true,
        successfulLogin: undefined,
      };
    case types.LOGIN.SUCCESS:
      return {
        ...state,
        userId: action.userId,
        token: action.token,
        loginLoading: false,
        successfulLogin: true,
      };
    case types.LOGIN.FAILURE:
      return {
        ...state,
        loginLoading: false,
        successfulLogin: false,
      };
    case types.CLEAN_USER_CREDENTIALS:
      return {
        ...initialState,
        userId: false,
        token: false,
      };
    case types.UPDATE_PERMISSION:
      return {
        ...state,
        rolesLoading: false,
        permission: action.permission,
      };
    case types.UPDATE_USER_INFO:
      return {
        ...state,
        email: action.email,
        username: action.username,
      };
    case types.RESET_PASSWORD.REQUEST:
      return {
        ...state,
        isResetingPassword: true,
      };
    case types.RESET_PASSWORD.RESPONSE:
      return {
        ...state,
        isResetingPassword: false,
      };
    case types.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL.STARTED:
      return {
        ...state,
        forgotPasswordLoading: true,
        forgotPasswordFormRequestSuccess: false,
        forgotPasswordFormRequestFail: false,
      };
    case types.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL.SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordFormRequestSuccess: true,
      };
    case types.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL.FAILURE:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordFormRequestSuccess: false,
        forgotPasswordFormRequestFail: true,
      };
    case types.CHANGE_PASSWORD_BY_TOKEN.STARTED:
      return {
        ...state,
        forgotPasswordLoading: true,
        forgotPasswordFormChangeSuccess: false,
        forgotPasswordFormChangeFail: false,
      };
    case types.CHANGE_PASSWORD_BY_TOKEN.SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordFormChangeSuccess: true,
      };
    case types.CHANGE_PASSWORD_BY_TOKEN.FAILURE:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordFormChangeFail: true,
      };
    case types.RESET_FORGOT_PASSWORD_FORM:
      return {
        ...state,
        ...forgotPasswordFormInitialState,
      };
    case types.CONFIRM_OTP:
      return {
        ...state,
        otp: action.payload.otp,
        uuid: action.payload.uuid,
        id: action.payload.id,
        isAIRoute: action.payload.isAIRoute,
      };
    case types.BLOCK_TWO_FACTOR_AUTH_FORM:
      return {
        ...state,
        twoFactorAuthBlocked: true,
      };
    case types.UNBLOCK_TWO_FACTOR_AUTH_FORM:
      return {
        ...state,
        twoFactorAuthBlocked: false,
      };
    case types.ATTEMPTS_COUNT_EXHAUSTED:
      return {
        ...state,
        attemptsCountExhausted: true,
      };
    case conferenceTypes.GET_BY_ID.SUCCESS:
    case conferenceTypes.GET_BY_ID.FAILURE:
    case conferenceTypes.GET_BY_LINKS_UUID.SUCCESS:
    case conferenceTypes.GET_BY_LINKS_UUID.FAILURE:
      return {
        ...state,
        otp: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/authentication.js